"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = require("./common");

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelidate/lib/validators/alphaNum.js
// module id = 2441
// module chunks = 1 4 10 12 13 15 35 36 39 40 41 42 44 50 52 53 54 55 56 57